import Image from "next/image";
import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import "react-bootstrap-typeahead/css/Typeahead.bs5.css";
import Badge from "react-bootstrap/Badge";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { webServiceClient } from "../../data/apiClient";
import * as ga from "../../lib/ga";
import useTrait from "../Common/syncUpdateState";
const MySwal = withReactContent(Swal);

const showAlert = (error) => {
  MySwal.fire({
    title: "Error Occured!",
    text: error,
    icon: "error",
    timerProgressBar: false,
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: "Close",
  });
};

const CupSearchComponent = (props) => {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const [isLoading, setIsLoading] = useState(false);
  const [cupNumber, setCupNumber] = useState("");
  const searchResult = useTrait([]);
  const isProduction = process.env.NODE_ENV === "production";

  const apiService = webServiceClient(setIsLoading);
  const cupNumberChange = (event) => {
    setCupNumber(event.target.value);
  };

  useEffect(() => {
    if (isProduction) {
      ga.event({
        action: cupNumber,
        params: {
          event_category: "Search Series",
        },
      });
    }
  }, [isProduction, cupNumber]);

  const doSearch = useCallback(async () => {
    const resp = await apiService.getProductByKey(cupNumber);
    searchResult.set(resp?.data?.result);
  }, []);

  const onSubmitResult = async (event) => {
    event.preventDefault();

    try {
      const resp = await apiService.getProductByKey(cupNumber);
      if (resp) {
        searchResult.set(resp?.data?.result);
      }
    } catch (err) {
      showAlert("Unexpected error occured doing Rego search");
    }
  };

  return (
    <>
      <Container>
        <div className='d-flex justify-content-center'>
          <div className='row g-2'>
            <div className='col-sm-8'>
              <input
                type='text'
                className='form-control mb-2 mr-sm-2'
                id='inlineFormInputName2'
                placeholder='Ryco Filter or Cup No'
                value={cupNumber}
                onChange={cupNumberChange}
              />
            </div>
            <div className='col-sm-4'>
              <button
                onClick={onSubmitResult}
                className='btn btn-primary mb-2 w-100'
              >
                {isLoading && (
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                  />
                )}
                {!isLoading && "Search"}
              </button>
            </div>
          </div>
        </div>
      </Container>
      <Container>
        <br />
        <Row style={{ border: "1px solid #eee" }}>
          {searchResult.get().itemList &&
            searchResult.get().itemList.map((item, index) => (
              <Col
                xs={6}
                md={3}
                key={"col_" + index}
                style={{
                  border: "1px solid #eee",
                  margin: "10px 5px",
                  width: "24%",
                  maxWidth: "24%",
                  minWidth: "24%",
                }}
              >
                {searchResult.get().isStockCode && item.imageUrl && (
                  <a href={"/part/" + item.assocStockCode}>
                    <div className='img-center text-center'>
                      <Image
                        responsive='true'
                        thumbnail='true'
                        alt='Product Image'
                        src={item.imageUrl}
                        layout='raw'
                        width={200}
                        height={150}
                      />
                    </div>
                  </a>
                )}
                {!searchResult.get().isStockCode && item.imageUrl && (
                  <a href={"/part/" + item.stockCode}>
                    <div className='img-center text-center'>
                      <Image
                        responsive='true'
                        thumbnail='true'
                        alt='Product Image'
                        src={item.imageUrl}
                        layout='raw'
                        width={200}
                        height={150}
                      />
                    </div>
                  </a>
                )}
                <Table>
                  <tbody>
                    <tr>
                      <td>
                        <a
                          target='_blank'
                          rel='noreferrer'
                          href={
                            "/part/" +
                            (searchResult.get().isStockCode
                              ? item.assocStockCode
                              : item.stockCode)
                          }
                        >
                          <b>
                            {searchResult.get().isStockCode
                              ? item.assocStockCode
                              : item.stockCode}
                          </b>
                        </a>
                      </td>
                      <td>{item.ItemName}</td>
                    </tr>
                    {item.noteText && (
                      <tr>
                        <td style={{ textAlign: "center" }}>
                          {" "}
                          <Badge
                            className='fa fa-info-circle'
                            style={{ color: "red", alignItems: "center" }}
                          ></Badge>{" "}
                          {item.noteText}
                        </td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            ))}
        </Row>
      </Container>
    </>
  );
};

export default CupSearchComponent;
